const DetailsActionTypes = {
  UPDATE_STATUS_DATA: "experimentDetails/UPDATE_STATUS_DATA",
  UPDATE_FEATURE_STATUS_DATA: "featureDetails/UPDATE_STATUS_DATA",
  FETCH_STATUS: "experimentDetails/FETCH_STATUS",
  FETCH_FEATURE_STATUS: "featureDetails/FETCH_STATUS"
};
export {
  DetailsActionTypes as default
};
//# sourceMappingURL=DetailsActionTypes.js.map
